import React from "react";

const ClearClockoutModal = ({ open, setOpen, onProceed }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white rounded-lg shadow-lg w-[350px] p-6">
        
        <div className="text-lg font-semibold text-start mb-4 text-center">
          Are you sure you want to clear clockout?
        </div>

        <div className="flex justify-end gap-3 mt-4">
          <button
            className="px-4 py-1 rounded border border-gray-300"
            onClick={() => setOpen(false)}
          >
            Cancel
          </button>

          <button
            className="px-4 py-1 rounded bg-[#900] text-white"
            onClick={() => {
              onProceed();
              setOpen(false);
            }}
          >
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClearClockoutModal;